import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { UserPermissionService } from '../services/user-permission-service';
import { useDefaultLoginRoute } from './use-user-setting';

export const useFirstDefaultRouteWithPermissions = () => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const defaultRoute = useDefaultLoginRoute();
  return useMemo(() => UserPermissionService.getFirstPermissableRouteUrl(userRoles, defaultRoute), [userRoles, defaultRoute]);
};
